import { writable } from "svelte/store";


const localGoogleAuthCreds = localStorage.getItem("localGoogleAuthCreds");
export const googleAuthCreds = writable(localGoogleAuthCreds);
googleAuthCreds.subscribe(value => {
    localStorage.setItem("localGoogleAuthCreds", value);
});

const localGoogleAuthToken = localStorage.getItem("localGoogleAuthToken");
export const googleAuthToken = writable(localGoogleAuthToken);
googleAuthToken.subscribe(value => {
    localStorage.setItem("localGoogleAuthToken", value);
});

export const quoteSelectedMaterial = writable("All");
export const yards = writable([]);

export const truckMarkers = writable([]);
export const siteMarkers = writable([]);
export const selectedJobs = writable([]);

export const loadAddresCoordinate = writable(null);
export const yardMarkers = writable([]);
export const yardPriceMarkers = writable([]);


export const routeSources = writable([]);
export const routeLines = writable([]);
export const routeTexts = writable([]);
export const routeTravelEstimates = writable({});

export const tripCalculations = writable([]);
export const tripCalculationsMarkers = writable([]);

export const loadAddressText = writable("");

export const customerQuote = writable({
    id: null,
    quoteNumber: null,
    quoteDate: new Date().toISOString().split('T')[0],
    validUntil: new Date(Date.now() + 30 * 24 * 60 * 60 * 1000).toISOString().split('T')[0],
    status: "draft",
    customerName: "",
    contactPerson: "",
    phone: "",
    email: "",
    siteAddress: "",
    notes: "Rates based on standard operating hours (07:00 - 17:00). Tolls and disposal fees included. Subject to clean tipping guidelines.",
    marginPercent: 15,
    margins: {
        tonneRate: { value: 0, mode: "percent" },
        costPerLoad: { value: 0, mode: "percent" },
        dayRate: { value: 0, mode: "percent" },
        cartageCost: { value: 0, mode: "percent" },
        totalTolls: { value: 0, mode: "percent" },
        totalCost: { value: 15, mode: "percent" }
    },
    allocatedTrucks: 1,
    haulagePackage: null,
    haulagePackages: [],
    activePackageId: null,
    activeMaterialTab: ""
});
if (typeof window !== "undefined") {
    window.__customerQuoteStore = customerQuote;
}

export const activeRouteSchedule = writable(null);

export const activeTab = writable("quotes");
export const selectedQuoteForJob = writable(null);
export const selectedJobForEdit = writable(null);
export const jobsListStore = writable([]);
export const liveJobsStore = writable([]);
export const showCustomerQuoteWindow = writable(true);

export const destinationModeStore = writable("commercial"); // "commercial" | "private_site" | "ad_hoc_site"
export const customDisposeSiteStore = writable(null);
export const selectedSavedSiteStore = writable(null);
